import LegalLayout, { Section } from "@/components/legal/LegalLayout";

export default function DeleteAccount() {
  return (
    <LegalLayout title="Delete Your Account & Data" updated="July 2, 2026" testid="delete-account-page">
      <p>
        You can delete your BLOQ Talk account and associated personal data at any time. This page
        explains how to request deletion, what is removed, and what we may retain. It applies to the
        BLOQ Talk mobile apps and the web application at bloqtalk.app (the "Service").
      </p>

      <Section heading="1. Delete From Within the App">
        <ol className="list-decimal space-y-2 pl-6">
          <li>Open BLOQ Talk and go to <strong className="text-white">Profile</strong>.</li>
          <li>Open <strong className="text-white">Settings</strong> (the gear icon).</li>
          <li>Select <strong className="text-white">Account</strong>, then <strong className="text-white">Delete Account</strong>.</li>
          <li>Confirm the request. Your account is scheduled for permanent deletion.</li>
        </ol>
      </Section>

      <Section heading="2. Request Deletion by Email">
        <p>
          If you can't access the app, email{" "}
          <a href="mailto:privacy@bloqtalk.app?subject=Account%20Deletion%20Request" className="text-bloq-mint hover:underline">
            privacy@bloqtalk.app
          </a>{" "}
          from the email address on your account with the subject "Account Deletion Request." To
          protect your account, we may ask you to verify ownership before we proceed. We aim to
          action verified requests within 30 days.
        </p>
      </Section>

      <Section heading="3. What Gets Deleted">
        <ul className="list-disc space-y-2 pl-6">
          <li>Your profile: email, username, display name, bio, and avatar.</li>
          <li>Your BLOQ Score, connections, BLOQ memberships, and connection requests.</li>
          <li>Your messages and content are deleted or de-identified. Direct messages are end-to-end encrypted and cannot be read by us.</li>
          <li>Your devices and active sessions are revoked.</li>
        </ul>
      </Section>

      <Section heading="4. What We May Retain">
        <p>
          After deletion we may retain a limited amount of information where necessary to comply
          with legal obligations, prevent fraud and abuse, resolve disputes, or enforce our
          agreements — for example, records of trust &amp; safety enforcement and minimal
          transaction or security logs. Retained data is kept only as long as required and is then
          deleted or de-identified.
        </p>
      </Section>

      <Section heading="5. Deletion Timeline">
        <p>
          In-app deletions are processed promptly, and email requests are actioned within 30 days
          of verification. Backups are purged on our normal rotation cycle. Once deletion is
          complete, your account cannot be recovered.
        </p>
      </Section>

      <Section heading="6. Questions">
        <p>
          For help with account or data deletion, contact{" "}
          <a href="mailto:privacy@bloqtalk.app" className="text-bloq-mint hover:underline">
            privacy@bloqtalk.app
          </a>
          . See also our{" "}
          <a href="/privacy" className="text-bloq-mint hover:underline">Privacy Policy</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
